import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { PanZoomModel } from 'ngx-panzoom';
import { DocumentApiClient } from 'src/app/services/document.apiclient';



export const ViewXmlModalOptions: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  centered: true,
  size: 'xl',
  windowClass: 'renderedModal'
};

@Component({
    templateUrl: './view-xml.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewXmlModal implements OnInit {

  @Input() documentId!: string;
  @Input() requestId!: string;

  translations: {
    columnTime: string;
    columnStatusCode: string;
    columnReference: string;
    columnDescription: string;
  } = <any>{};

  constructor(private activeModal: NgbActiveModal, private sanitizer: DomSanitizer, private documentService: DocumentApiClient, private translateService: TranslateService) {
    this.getTranslations();
   }

  innerHtml!: string;
  currentPageNumber: number = 1;
  pageWidth: number = 0;
  pageHeight: number = 0;
  isMobile: any;
  setPlaceholder: boolean = false;

  pageElement!: HTMLElement;
  panZoomModelData!: PanZoomModel;
  panleft: number = 0;
  pantop: number = 0;
  scrollHeight!: any;

  xbrlTemplate = 'assets/temp_html_pages/xbrl.html';
  xbrlTemp!: string;
  renderedDocument!: SafeHtml;

  async ngOnInit() {
    await this.renderXml();
  }

  close() {
    this.activeModal.close();
  }

  //#region -- Private Methods --
  private async renderXml() {
    if(this.renderedDocument) return;
    try {

      (await this.documentService.getRenderedHtml(this.requestId, this.documentId))
        .subscribe({
          error: (error: HttpErrorResponse) => console.error(error),
          next: (xmlDocumentData: any) => {
            const xml = new DOMParser().parseFromString(xmlDocumentData, 'text/xml');

            const headingLines: string[] = [];

            // Iterate through each child node to be able to add the heada
            xml.documentElement?.childNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // Add the element name and value to the array
                headingLines.push(`${node.nodeName}: ${node.textContent}`);
              }
            });

            // Join the lines with <br> tags
            const xmlString = headingLines.join('<br>');

            this.renderedDocument = this.sanitizer.bypassSecurityTrustHtml(xmlString);
          }
        });
    } catch (error) {
      console.error('Error rendering XML:', error);
    }
  }

  private getTranslations() {
    this.translateService.get([
      'Request.Rendered.ColumnTime',
      'Request.Rendered.ColumnStatusCode',
      'Request.Rendered.ColumnReference',
      'Request.Rendered.ColumnDescription'
    ]).subscribe(translation => {
      this.translations.columnTime = translation['Request.Rendered.ColumnTime'];
      this.translations.columnStatusCode = translation['Request.Rendered.ColumnStatusCode'];
      this.translations.columnReference = translation['Request.Rendered.ColumnReference'];
      this.translations.columnDescription = translation['Request.Rendered.ColumnDescription'];
    });
  }
  //#endregion
}